// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import React from 'react';
import './Input.css';

interface InputProps {
  label: string;
  value: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  type?: string;
}

const Input: React.FC<InputProps> = ({ label, value, onChange, placeholder, disabled = false, type = 'text' }) => {
  return (
    <div className="interview-input-group">
      <label className="interview-input-label">{label}</label>
      <input
        type={type}
        className="interview-input"
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        placeholder={placeholder}
        disabled={disabled}
      />
    </div>
  );
};

export default Input;
